// extracted by mini-css-extract-plugin
export default {"appNavHeader":"AppHeaderHomeLink_appNavHeader__+hmFL","homeIcon":"AppHeaderHomeLink_homeIcon__EdVOY"};